import * as React from 'react';
import { Handle, HandleProps } from 'rc-slider';
import Tooltip from 'rc-tooltip';
import './TooltipHandle.scss';

export interface TooltipHandleProps extends HandleProps {
  dragging?: boolean;
  index: number;
  value: number;
}


export const handleWithTooltip: React.FunctionComponent<TooltipHandleProps> = (props) => {
  const { index, ...restProps } = props;
  return (
    <Tooltip
      prefixCls="tooltip"
      overlay={props.value}
      defaultVisible={true}
      visible={true}
      placement="top"
      key={index}
      destroyTooltipOnHide={false}
    > 
      <Handle {...restProps} />
    </Tooltip>
  );
};

export default {
  handleWithTooltip,
};